var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogonexternegro(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04323 14.9648C2.43421 13.5738 4.68601 13.5738 6.07699 14.9648L15.4831 24.3709C16.8741 25.7619 19.1259 25.7619 20.5169 24.3709L29.923 14.9648C31.314 13.5738 33.5658 13.5738 34.9568 14.9648C36.3477 16.3558 36.3477 18.6076 34.9568 19.9986L20.5169 34.4384C19.1259 35.8294 16.8741 35.8294 15.4831 34.4384L1.04323 19.9986C-0.347744 18.6076 -0.347744 16.3558 1.04323 14.9648Z",
    fill: "#0F1010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 14.8073C22.0916 14.8073 25.4063 11.4926 25.4063 7.40366C25.4063 3.31473 22.0916 0 18.0027 0C13.9137 0 10.599 3.31473 10.599 7.40366C10.599 11.4926 13.9137 14.8073 18.0027 14.8073Z",
    fill: "#0F1010"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonexternegro);
export default __webpack_public_path__ + "static/assets/logonexternegro.svg";
export { ForwardRef as ReactComponent };